import React, { useEffect } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// import { Acl } from 'modules/common/components/Acl';
// import { getJson } from 'session';
import { ConfirmAlert } from 'modules/common/components/Alert';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { ucwords } from 'helper';
import * as actions from '../action';
import * as c from '../constant';

function FeeContent({
  handleModal,
  feeId,
  getSingleFee,
  feeInfo,
  removeFee,
  getFeeList,
  isLoading,
}) {
  //   const permissions = getJson('permissions');
  const history = useHistory();

  useEffect(() => {
    if (_.isEmpty(feeId)) return;
    getSingleFee(feeId);
  }, [feeId]);

  const handleDelete = () => {
    ConfirmAlert(
      'Are you sure, you want to remove?',
      () => {
        removeFee(feeId, () => {
          getFeeList({}, (response) => {
            const id = _.get(response, 'data.0.id');
            history.push(`/civil-registry/settings/fees/${id}`);
          });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="container-fluid position-relative">
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            backgroundColor: 'rgba(0,0,0,0.2)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: 'white',
            fontSize: '1.5rem',
            fontWeight: 'bold',
          }}
        >
          Loading...
        </div>
      )}

      <div className="card-body">
        <button
          type="button"
          onClick={() => handleModal()}
          className="btn btn-success text-dark btn-sm d-flex align-items-center justify-content-center ml-auto"
        >
          <i className="fas fa-plus mr-1" />
          Add Fee
        </button>

        {!_.isEmpty(feeInfo) ? (
          <>
            <div className="d-flex align-items-center mt-3">
              <h2 className="font-weight-bold m-0">
                {_.get(feeInfo, 'attributes.name')}
              </h2>

              <button
                type="button"
                className="btn btn-sm btn-primary ml-auto"
                onClick={() => handleModal(feeInfo.attributes, feeInfo.id)}
              >
                Edit
              </button>

              <button
                type="button"
                className="btn btn-sm btn-danger ml-1"
                onClick={() => handleDelete()}
              >
                Delete
              </button>
            </div>

            <div className="p-3 border rounded mt-3 table-responsive">
              <table className="transaction-table table table-borderless table-sm">
                <tbody>
                  <tr>
                    <td className="text-dark" width="250">
                      Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>{_.get(feeInfo, 'attributes.name')}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Description
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>{_.get(feeInfo, 'attributes.description')}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Fee Type
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>{ucwords(_.get(feeInfo, 'attributes.fee_type', '').replace(/_/g, ' '))}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Amount
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>{_.get(feeInfo, 'attributes.amount')}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      Additional Copy Amount
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>{_.get(feeInfo, 'attributes.additional_copy_fee') || '0.00'}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      For Birth Certificate
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {_.get(
                          feeInfo,
                          'attributes.for_birth_certificate'
                        ) ? 'Yes' : 'No'}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      For Death Certificate
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {_.get(
                          feeInfo,
                          'attributes.for_death_certificate'
                        ) ? 'Yes' : 'No'}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      For Marriage Certificate
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {_.get(
                          feeInfo,
                          'attributes.for_marriage_certificate'
                        ) ? 'Yes' : 'No'}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="250">
                      DST
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td colSpan={4}>
                      <b>
                        {_.get(
                          feeInfo,
                          'attributes.is_documentary_stamp'
                        ) ? 'Yes' : 'No'}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h4>Purposes</h4>
              <ul className="list-group">
                {_.get(feeInfo, 'attributes.purposes', []).map((purpose) => (
                  <li key={purpose.id} className="list-group-item">
                    {purpose.name}
                  </li>
                ))}
              </ul>
            </div>
          </>
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

FeeContent.propTypes = {
  handleModal: PropTypes.instanceOf(Function).isRequired,
  getSingleFee: PropTypes.instanceOf(Function).isRequired,
  removeFee: PropTypes.instanceOf(Function).isRequired,
  getFeeList: PropTypes.instanceOf(Function).isRequired,
  feeInfo: PropTypes.instanceOf(Object).isRequired,
  feeId: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  feeInfo: _.get(api, `${c.GET_SINGLE_FEE}.item`) || {},
  feeId: _.get(match, 'params.feeId') || '',
  isLoading: api.loading.indexOf(c.GET_SINGLE_FEE) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FeeContent);
